<template>
  <div>
    <load-profile />
    <!-- Table Container Card -->
    <b-card>
      <validation-observer
        ref="updateForm"
        #default="{ invalid }"
      >
        <!-- form -->
        <n-form-confirmation
          key="updateForm"
          :form="$refs.updateForm"
          :disabled="invalid"
          @submit="submit"
        >
          <n-input
            v-model="data"
            :fields="fields"
            :init-value="initData"
            class="data-form"
          />
          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <n-button-loading
                v-if="$can('update', 'bet-setting')"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mt-1"
                :loading="loading"
                :disabled="invalid"
              >
                {{ $t("button.saveChanges") }}
              </n-button-loading>
            </b-col>
          </b-row>
        </n-form-confirmation>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardText,
  BLink,
  BFormRadioGroup,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import Ripple from 'vue-ripple-directive'
import NButtonLoading from '@/components/NButtonLoading'
import NFormConfirmation from '@/components/NFormConfirmation'
import NSingleSelect from '@/components/NSingleSelect'
import NInput from '@/components/NInput'
import NAsyncSingleSelect from '@/components/NAsyncSingleSelect'
import FormInput from './formInput'

const BetSettingRepository = Repository.get('betSetting')

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    BFormRadioGroup,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    NSingleSelect,
    NAsyncSingleSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        cutAmountPerBet: 0,
        cutMaxPayout: 0,
        cutMinPayout: 0,
        cutPercentPerBet: 0,
        cutType: 0,
        isCutPercent: 0,
      },
      initData: {},
      loading: false,
    }
  },
  mounted() {
    this.show()
  },
  methods: {
    show() {
      BetSettingRepository.show().then(response => {
        let listUserAutoCancel = []
        if (response?.data?.data?.listUserAutoCancel) {
          listUserAutoCancel = response.data.data.listUserAutoCancel.map(item => item.id)
        }
        let listVvipAgent = []
        if (response?.data?.data?.listVvipAgent) {
          listVvipAgent = response.data.data.listVvipAgent
            .filter(item => item.id != null)
            .map(item => item.id)
        }

        this.initData = {
          ...response.data.data,
          listUserAutoCancel,
          listVvipAgent,
        }
      })
    },
    submit() {
      this.$refs.updateForm.validate().then(success => {
        if (success) {
          this.loading = true
          BetSettingRepository.update(this.data)
            .then(() => {
              this.$swal({
                text: this.$t('alert.saveSuccess'),
                icon: 'success',
                confirmButtonText: this.$t('button.close'),
              })
            })
            .catch(error => {
              if (error.response?.data?.message) {
                this.$refs.updateForm.setErrors(error.response?.data?.message)
              }
            })
            .then(() => {
              this.loading = false
            })
        }
      })
    },
  },
  setup() {
    const fields = FormInput.map(value => value)

    return { fields }
  },
}
</script>
